import { SetUreadMessage, ToggleLoginModal, ChangeBookingAction } from './../../../core/store/general/actions';
import { DashboardService } from './../../../core/services/dashboard.service';
import { IRequest } from './../../../core/models/request';
import {
    getHeaderState, getLastRequestAsked, getHotelInfo, getUserInfo, getUnreadMessages,
    isLoginModalOpened,
    getActiveOffers
} from './../../../core/store/general/selectors';
import { HotelHeaderInfo } from './../../../core/store/general/state';
import { SharedContainer } from './../../shared.container';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { Angulartics2 } from 'angulartics2';
import { act } from '@ngrx/effects';

@Component({
    selector: 'app-vervendo-header',
    templateUrl: 'header.component.html',
    styleUrls: ['header.component.css', 'header.component.scss']
})

export class HeaderComponent implements OnInit {

    headerType: string = String('home');
    userlogged: boolean;
    selectedRequest: IRequest;
    hotelInfo: HotelHeaderInfo;
    userInfo;
    unreadMessages;
    activeOffers;
    isNavOpen = false;
    dashheader = false;
    inSearch: boolean;
    showPRbtn = true;
    inBookingPath: boolean;

    @ViewChild('loginModal', { static: true }) loginModal;
    constructor(protected sharedContainer: SharedContainer,
        protected dashboardService: DashboardService, protected location: Location,
        protected router: Router, protected angulartics2: Angulartics2) { }

    ngOnInit() {
        this.router.events.subscribe(data => {
            if (this.location.path().includes('booking')) {
                this.inBookingPath = true;
                setTimeout(() => {
                    const header = <HTMLElement>document.getElementById('home-header');
                    header.classList.add('hidden');
                }, 1000);
            } else {
                setTimeout(() => {
                    const header = <HTMLElement>document.getElementById('home-header');
                    if (header.classList.contains('hidden')) {
                        header.classList.remove('hidden');
                    }
                }, 1000);
                this.inBookingPath = false;
            }
            if (this.location.path() === '/search') {
                this.inSearch = true;
            } else {
                this.inSearch = false;
            }
        });
        this.getEnvironment();
        this.userlogged = this.sharedContainer.isLoggedIn$;
        this.sharedContainer.generalState$.select(getUserInfo)
            .subscribe(request => {
                this.userInfo = request;
                this.userlogged = this.sharedContainer.isLoggedIn$;
                if (this.userInfo === undefined || this.userInfo === null) { return; }
                this.dashboardService.getUsersUnread(this.userInfo.id).subscribe(res => {
                    this.sharedContainer.generalState$.dispatch(new SetUreadMessage(1, { unreadMessages: res }));
                });

                this.dashboardService.getAllActiveOffersByUser(this.userInfo.id).subscribe(res => {
                    // console.log(res);
                    if (res === 0) {
                        this.activeOffers = 0;
                    } else {
                        // this.activeOffers = res.reduce((sum, singleRequest) =>  sum + singleRequest.offerCount, 0);
                        this.activeOffers = res;
                        // console.log('Active offers:', this.activeOffers);
                    }
                });
            });

        this.sharedContainer.generalState$.select(getHeaderState)
            .subscribe(headerType => {
                this.headerType = headerType.trim();
                this.dashheader = headerType === 'dashheader';
            });

        this.sharedContainer.generalState$.select(getLastRequestAsked)
            .subscribe(request => {
                this.selectedRequest = request;
            });

        this.sharedContainer.generalState$.select(getHotelInfo)
            .subscribe(request => {
                this.hotelInfo = request;
            });

        this.sharedContainer.generalState$.select(getUnreadMessages)
            .subscribe(request => {
                this.unreadMessages = request;
            });

        this.sharedContainer.generalState$.select(getActiveOffers)
            .subscribe(request => {
                this.activeOffers = request;
            });

        this.sharedContainer.generalState$.select(isLoginModalOpened).subscribe(opened => {
            if (opened === true) {
                this.bookNow();
                this.sharedContainer.generalState$.dispatch(new ToggleLoginModal(1, { loginModalOpened: false }));
            }
        });

    }

    getEnvironment() {
        if (!environment.production) {
            this.showPRbtn = false;
        }
    }

    burgerLogIn() {
        this.angulartics2.eventTrack.next({ action: 'burgerLogin' });
        this.router.navigate(['login-page/'], { queryParams: { intent: 'login' } });
        this.closeNavHome();
    }

    burgerSignUp() {
        this.angulartics2.eventTrack.next({ action: 'burgerSignup' });
        this.router.navigate(['login-page/'], { queryParams: { intent: 'signup' } });
        this.closeNavHome();
    }

    bookNow() {
        if (this.userlogged) {
            this.sharedContainer.generalState$.dispatch(new ChangeBookingAction(1, { isBookingActionEnabled: true }));
        } else {
            this.openLoginModal(false);
        }
    }

    changeHeader() {
        alert(this.headerType);
    }

    getHeader() {
        return this.headerType;
    }

    logout(ev) {
        this.sharedContainer.logout();
    }

    goToNewSearch() {
        this.router.navigate(['/search']);
        this.closeNavHome();
    }

    openLoginModal(data) {
        this.loginModal.showModal(data);
    }

    modalClosed(data) { }

    openNavHome() {
        const divs = new Array();
        if (this.headerType === 'booking') {
            divs.push('results');
            divs.push('about');
            divs.push('contact-us');
        } else if (this.headerType === 'Results') {
            divs.push('resultsPage');
            divs.push('about');
            divs.push('contact-us');
        } else if (this.headerType === 'SingleHotel') {
            divs.push('singleHotel');
            divs.push('about');
            divs.push('contact-us');
        } else {
            divs.push('home');
            divs.push('about');
            divs.push('contact-us');
        }
        divs.push('home-header');
        this.openNav(divs);
    }

    closeNavHome() {
        const divs = new Array();
        if (this.headerType === 'booking') {
            divs.push('results');
            divs.push('about');
            divs.push('contact-us');
        } else if (this.headerType === 'Results') {
            divs.push('resultsPage');
            divs.push('about');
            divs.push('contact-us');
        } else {
            divs.push('home');
            divs.push('about');
            divs.push('contact-us');
        }

        divs.push('home-header');
        this.closeNav(divs);
    }

    openNav(divs) {
        if (!this.isNavOpen) {
            const div0 = document.getElementById(divs[0]);
            document.getElementById('mySideNav').style.width = '100vw';
            if (divs[1] === 'results-header') {
                document.getElementById(divs[1]).style.marginLeft = '38%';
            } else {
                // document.getElementById(divs[3]).style.marginLeft = '60%';
                for (let i = 0; i < divs.length; i++) {
                    if (document.getElementById(divs[i])) {
                        document.getElementById(divs[i]).style.width = '100%';
                        // document.getElementById(divs[i]).style.marginLeft = '60%';
                    }
                }
            }
            if (div0) {
                div0.style.marginLeft = '60%';
                document.getElementById(divs[0]).style.width = '100%';
            }
            document.getElementById(divs[3]).style.width = '100%';

            this.isNavOpen = !this.isNavOpen;
        } else {
            this.closeNav(divs);
        }

    }

    closeNav(divs) {
        document.getElementById('mySideNav').style.width = '0';
        const div0 = document.getElementById(divs[0]);
        if (div0) {
            div0.style.marginLeft = '0';
        }
        for (let i = 0; i < divs.length; i++) {
            if (document.getElementById(divs[i])) {
                document.getElementById(divs[i]).style.marginLeft = '0';
            }
        }
        document.getElementById(divs[3]).style.marginLeft = '0';
        this.isNavOpen = !this.isNavOpen;
    }

    getAdults() {
        return this.selectedRequest.roompersons.reduce((sum, current) => (sum + parseInt(current.adults, 10)), 0);
    }

    getChildren() {
        return this.selectedRequest.roompersons.reduce((sum, current) => (sum + current.children.length), 0);
    }

    getFormatedDate(date) {
        const selectedDate = new Date(date);
        return (selectedDate.getDate() + '/'
            + (selectedDate.getMonth() + 1) + '/'
            + selectedDate.getFullYear());
    }

    getArray(size) {
        return new Array(size).fill(0);
    }

    goBack() {
        if (window.history.length <= 3) {
            window.location.href = '/my-dashboard/my-requests';
        } else {
            this.location.back();
        }
    }

    hidePropertyButton() {

        const x = document.getElementById('property');
        x.style.visibility = 'hidden';
    }

    hideSecondaryMenu() {

        const y = document.getElementById('menuSecond');
        y.style.visibility = 'hidden';
    }

    showPropertyButton() {

        const x = document.getElementById('property');
        x.style.visibility = 'visible';
    }

    showSecondaryMenu() {

        const y = document.getElementById('menuSecond');
        y.style.visibility = 'visible';
    }

    showBookInfo() {
        const v = document.getElementById('bookInfo');
        v.style.visibility = 'visible';
    }

    hideBookInfo() {
        const w = document.getElementById('bookInfo');
        w.style.visibility = 'visible';
    }

    isMobile() {

        const w = window.innerWidth;
        if (w < 992) {
            return true;
        }
        return false;
    }

    angulartics2Track(action: string) {
        this.angulartics2.eventTrack.next({ action: action });
    }
}
